import React, { useRef, useState, useEffect, Fragment } from 'react'
import styles from './ContextMenu.module.scss'
import Category from './Category'
import { ContextMenuProps } from './types'

const getOffset = el => {
  if (!el) return null

  const rect = el.getBoundingClientRect()
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  }
};

const ContextMenu = (props: ContextMenuProps) => {
  const {
    leftOffsetRatio = 1,
    position,
    options,
    hide,
    containerHeight,
    containerWidth
  } = props

  const containerRef: any = useRef()
  const [statePosition, setStatePosition] = useState({ ...position })

  useEffect(() => {
    const handleOutsideClick = e => {
      if (containerRef.current.contains(e.target)) return
      hide()
    };

    document.addEventListener('click', handleOutsideClick, false)
    return () => {
      document.removeEventListener('click', handleOutsideClick, false)
    };
  }, [containerRef, hide])

  useEffect(() => {
    if (!containerRef || !containerRef.current) return

    const { clientHeight, clientWidth } = containerRef.current
    const { top: topOffset, left: leftOffset } = getOffset(containerRef.current)


    const { innerHeight: windowHeight, innerWidth: windowWidth } = window;

    // const heightWontFit = windowHeight - topOffset < clientHeight;
    // const widthWontFit = windowWidth - leftOffset < clientWidth;

    const heightWontFit = windowHeight - topOffset < clientHeight
    const widthWontFit = windowWidth - leftOffset < clientWidth

    const needToSetNewPosition = heightWontFit || widthWontFit

    needToSetNewPosition && setStatePosition(s => ({
      ...s,
      top: heightWontFit ? s.top - clientHeight : s.top,
      left: widthWontFit ? s.left - (clientWidth * leftOffsetRatio) : s.left
    }))
  }, [containerRef, leftOffsetRatio, containerWidth, containerHeight])

  const categoriesArray = Object.keys(options)
    .sort()
    .map(categoryIndex => options[categoryIndex])

  return (
    <div
      ref={containerRef}
      className={styles.container}
      style={{ ...statePosition }}
    >
      {
        categoriesArray.map((category, index) =>
          <Fragment key={index}>
            <Category options={category} hide={hide} containerHeight={containerHeight} containerWidth={containerWidth} />
            {index !== categoriesArray.length - 1 &&
              <div className={styles.separator} />
            }
          </Fragment>
        )
      }
    </div>
  )
};

export default ContextMenu
